document.querySelectorAll('.join-the-team__carousel').forEach((carousel) => {
  if (carousel.dataset.cloned === 'true') return;

  const slides = Array.from(carousel.children);
  slides.forEach((slide) => {
    carousel.appendChild(slide.cloneNode(true));
  });
  carousel.dataset.cloned = 'true';

  const restartAnimation = () => {
    carousel.style.animation = 'none';
    carousel.offsetHeight;
    carousel.style.animation = '';
  };

  carousel.addEventListener('animationend', restartAnimation);
});
